document.addEventListener("DOMContentLoaded", function () {
    const infoCards = document.querySelectorAll('.info-card--toggle')
    if(infoCards != null && infoCards.length > 0){
        infoCards.forEach(infoCard => {
            const toggleButton = infoCard.querySelector('.info-card__toggle-button .btn')

            // Toggle functionality
            toggleButton.onclick = () => {
                if (infoCard.classList.contains('isExpanded')) {
                    // Shrink
                    infoCard.classList.remove('isExpanded')
                    toggleButton.setAttribute('aria-expanded', false)
                    infoCard.scrollIntoView()
                } else {
                    // Expand
                    infoCard.classList.add('isExpanded')
                    toggleButton.setAttribute('aria-expanded', true)
                }
            }
        })
    }
})